import React, { useState, useEffect } from 'react';
import { Button, Tag, message, Empty, Spin, Timeline } from 'antd';
import { userActionRecord } from '@/services/userManager';
import { guuid } from '@/utils/utils';

const TouchRecordView = (props) => {
  // eslint-disable-next-line react/prop-types
  const { userId } = props;
  const [touchRecord, setTouchRecord] = useState([]);
  const [touchCurrentPage, setTouchCurrentPage] = useState(1);
  const [touchIsEnd, setTouchIsEnd] = useState(false);
  const [touchIsLoading, setTouchIsLoading] = useState(false);
  useEffect(() => {
    // 请求第一页
    getTouchList();
  }, []);
  const getTouchList = async () => {
    setTouchIsLoading(true);
    userActionRecord({
      requestData: { userId: userId },
      // requestData: { userId: 570830080 },
      page: {
        currentPage: touchCurrentPage,
        pageSize: 10,
      },
    }).then(({ page, code, data, msg }) => {
      setTouchIsLoading(false);
      if (code === '00000') {
        const newRecord = [...touchRecord, ...data];
        setTouchRecord(newRecord || []);
        if (newRecord.length === page.count) {
          setTouchIsEnd(true);
        }
        // page++
        setTouchCurrentPage(touchCurrentPage + 1);
      } else {
        message.error(msg);
      }
    });
  };

  return (
    <div>
      {touchRecord.length === 0 ? (
        <div>
          <Empty>
            {' '}
            <Spin hidden={!touchIsLoading} />{' '}
          </Empty>
        </div>
      ) : (
        <div style={{ textAlign: 'left', marginTop: 10, marginLeft: 10 }}>
          <Timeline pending={touchIsLoading ? '加载中..' : ''} mode={'left'}>
            {touchRecord?.map((e) => {
              return (
                <div
                  key={guuid()}
                  style={{ display: 'flex', position: 'relative' }}
                >
                  <div style={{ width: 100, position: 'absolute', top: -10 }}>
                    {e?.ctime}
                  </div>
                  <Timeline.Item
                    key={guuid()}
                    position={'left'}
                    style={{
                      padding: 0,
                      marginLeft: 100,

                      minHeight: 100,
                      textAlign: 'left',
                      width: '100%',
                    }}
                  >
                    <div style={{ display: 'flex', width: '100%' }}>
                      <Tag
                        style={{
                          height: 20,
                          width: 120,
                          textAlign: 'center',
                        }}
                      >
                        {e?.actionName}
                      </Tag>
                      <div
                        style={{
                          background: '#f5f5f5',
                          width: '100%',
                          minHeight: 60,
                          padding: 2,
                        }}
                      >
                        {e?.message}
                      </div>
                    </div>
                  </Timeline.Item>
                </div>
              );
            })}
          </Timeline>
          <Button
            hidden={touchIsEnd}
            onClick={getTouchList}
            type="primary"
            style={{ marginTop: 16, marginLeft: 50, width: 100 }}
          >
            更多
          </Button>
        </div>
      )}
    </div>
  );
};

export default TouchRecordView;
